import { observer } from 'mobx-react';
import { FC } from 'react';
import { T, TPlainTextKey } from '../../../../../Translations';
import ChevronBackground from '../../../../Cutesies/ChevronBackground';
import Logo from '../../../../Cutesies/Logo';

interface Props {
  Image: FC<{ width?: string; height?: string }>;
  headingText: TPlainTextKey;
}

function CoachRoleCelebration({ Image, headingText }: Props) {
  return (
    <div className="h-screen w-full">
      <div className="w-full bg-white py-4 pl-16 pr-8 z-20 relative h-[88px] flex items-center">
        <div className="w-[140px] h-[23px]">
          <Logo />
        </div>
      </div>

      <div className="relative h-[calc(100vh-88px)] w-full overflow-hidden">
        <ChevronBackground />

        <div className="relative z-10 flex flex-col items-center pt-16 pb-8 px-8 h-full">
          <Image width="452" height="293" />
          <div className="my-6 text-center mx-auto w-4/5 lg:w-3/5">
            <h1 className="my-6 text-3xl font-medium">
              <T kind={headingText} />
            </h1>
            <p className="text-sm width-4/5 lg:w-3/5 mx-auto">
              <T kind="Refresh your Coaching Profiles page to preview, edit, or update the student's access to the collection." />
            </p>
          </div>
          <button
            className="w-64 py-2 bg-white border border-teal-600 text-teal-600 rounded-md hover:bg-blue-50 transition-colors text-sm font-medium"
            onClick={() => window.close()}
          >
            <T kind="Close this tab" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default observer(CoachRoleCelebration);
